import { Component, computed, input, model, output } from '@angular/core';
import { EmailDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '../../../edit-wrapper/form-edit-wrapper.component';
import { AuraContactInfosEmailDisplayComponent } from '../display/contact-infos-email-display.component';
import { AuraContactInfosEmailFormComponent } from '../form/contact-infos-email-form.component';

@Component({
  selector: 'aura-contact-infos-email-edit',
  imports: [
    AuraEditWrapperComponent,
    AuraContactInfosEmailFormComponent,
    AuraContactInfosEmailDisplayComponent,
  ],
  templateUrl: './contact-infos-email-edit.component.html',
})
export class AuraContactInfosEmailEditComponent {
  isEditing = model<boolean>(false);
  isAllowedToEdit = input<boolean>(false);

  initialEmail = input.required<string>();
  emailSaved = output<EmailDto>();

  currentEmail = computed<EmailDto | null>(() => {
    const email = this.initialEmail();
    return email ? { email } : null;
  });
}
